import { Component, NgZone, OnInit } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { WordOfDuressComponent } from './word-of-duress/word-of-duress.component';
import { GlobalVariablesService } from '../../../../services/global-variables.service';
import { StorageService } from '../../../../services/commons/storage.service';
import { ContactUser } from '../../../../models/ContactUser';
import { Installation } from '../../../../models/Installation';
import { GlobalMethodsService } from '../../../../services/global-methods.service';
import { TranslateConfigService } from 'src/app/services/commons/translate-config.service';
import { ContactChangeRequest } from '../../../../services/SicorService/RequestObject/ContactChangeRequest';
import { DefaultModalComponent } from '../../default-modal/default-modal.component';
import { Codeword } from '../../../../models/Codeword';
import { AppUserHomeRequest } from '../../../../services/SicorService/RequestObject/AppUserHomeRequest';
import { ProtocolService } from '../../../../services/commons/protocol.service';
import { ModalService } from '../../../../services/commons/modal.service';
import { AuthService } from 'src/app/services/commons/auth.service';
import { OpenNativeSettings } from '@ionic-native/open-native-settings/ngx';
import { ProfileInstallationService } from 'src/app/services/commons/profile-installation.service';
import { NavigationService } from '../../../../services/commons/navigation.service';
import { FirebaseCrashlytics } from '@capacitor-community/firebase-crashlytics';

@Component({
  selector: 'app-protocol',
  templateUrl: './protocol.component.html',
  styleUrls: ['./protocol.component.scss'],
})
export class ProtocolComponent implements OnInit {

  public user: any;
  public contactsUsersList: ContactUser[] = [];
  public currentInstallation: Installation = new Installation();
  public contactUser: ContactUser = new ContactUser();
  public codewordsList: Codeword[] = [];
  public requestParams: AppUserHomeRequest;
  public openClassInBrowser = '';
  public isServiceBusy = false;
  public masterUsersList: ContactUser[] = [];
  public masterUser: boolean;


  constructor(private modalCtrl: ModalController,
    private zone: NgZone,
    public gvs: GlobalVariablesService,
    private storage: StorageService,
    private infInstallationService: ProfileInstallationService,
    public gms: GlobalMethodsService,
    private translate: TranslateConfigService,
    private defaultModalComponent: DefaultModalComponent,
    private protocolService: ProtocolService,
    public platform: Platform,
    public modalService: ModalService,
    public navigation: NavigationService,
    private authService: AuthService,
    private openNativeSettings: OpenNativeSettings) { }

  async ngOnInit() {
    this.currentInstallation = this.gvs.currentInstallation;
    this.user = this.gvs.user.userName;
    await this.getContactsUsers();
    if (this.platform.is('desktop')) {
      this.openClassInBrowser = 'open';
    }
  }

  ionViewWillEnter() {
    this.gms.analyticsTrackEvent('openScreen', { screenName: 'Protocolo', contentGroup: 'Protocolo' });
    this.gms.setLoadingTrue();
  }

  async ionViewDidEnter() {
    this.gms.setLoadingFalse();
    this.gvs.modalLoaded = 'empty';
  }

  dismiss(value) {
    this.modalService.hide('protocolModal', value);
  }

  togglePanel(element) {
    element.classList.toggle('open');
  }

  async getContactsUsers() {
    const checkInternet = await this.gms.checkInternet();
    if (checkInternet) {
      try {
        this.contactsUsersList = await this.infInstallationService.getContactsUser(this.user, this.currentInstallation.s_ins, 1);
        this.masterUsersList = await this.infInstallationService.getContactsUser(this.user, this.currentInstallation.s_ins, 0);
        if (this.masterUsersList.length > 0) {
          this.contactUser = this.masterUsersList.find(x => x.email1.toLowerCase() === this.user.toLowerCase());
          this.masterUsersList = this.masterUsersList.filter(contact => (contact.ilevel === 2));
          this.masterUser = this.masterUsersList.find(x => x.email1.toLowerCase() === this.user.toLowerCase() && x.ilevel === 2) ? true : false;
        }
      }
      catch (e) {
        const message = JSON.stringify(e);
        await FirebaseCrashlytics.recordException({ message: message });
        this.modalCtrl.dismiss(false, '', 'loadSpinner');
        this.modalCtrl.dismiss(false, '', 'protocolModal');
      }
    } else {
      this.modalCtrl.dismiss(false, '', 'protocolModal');
      await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.noInternetConnection'),
        'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
    }
    // this.contactsUsersList = this.contactsUsersList.filter(contact => contact.type === 0 || contact.type === 2);
  }

  // TO DO Actualmente en desuso
  // async openConfirmDeleteContactModal(contact) {
  //   const modal = await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.confirmDelete'), '', 'modal-default',
  //     await this.translate.getTranslate('BUTTON.delete'), this.translate.getTranslate('BUTTON.cancel'));
  //   modal.onDidDismiss().then(async res => {
  //     if (res.data != null && res.data.result && res.data.result != null) {
  //       await this.gms.loading();
  //       this.contactUser = contact;
  //       await this.changeContact(2);
  //       await this.getContactsUsers();
  //       this.modalCtrl.dismiss(false, '', 'loadSpinner');
  //     }
  //   });
  // }

  // async changeContact(opc) {
  //   const checkInternet = await this.gms.checkInternet();
  //   if (checkInternet) {
  //     let response = await this.infInstallationService.changeProfileData(this.buildContactChangeRequest(opc));
  //   } else {
  //     await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.noInternetConnection'),
  //       'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
  //   }
  // }

  // buildContactChangeRequest(opc) {
  //   const contactChangeRequest: ContactChangeRequest = new ContactChangeRequest(
  //     this.user, this.currentInstallation.s_ins, this.contactUser.pix, this.contactUser.s_cont, this.contactUser.ix, this.contactUser.code,
  //     this.contactUser.name, this.contactUser.street1, this.contactUser.zip, this.contactUser.city, this.contactUser.state,
  //     this.contactUser.phone1, this.contactUser.phone2, this.contactUser.phone3, this.contactUser.email1, this.contactUser.email2,
  //     this.contactUser.email_flg, this.contactUser.push_flg, this.contactUser.lix, this.contactUser.s_pc, opc);
  //   return contactChangeRequest;
  // }

  // Default modal
  async wordOfDuressModal(type: string) {
    if (this.isServiceBusy) {
      return;
    }
    const checkInternet = await this.gms.checkInternet();
    if (checkInternet) {
      this.isServiceBusy = true;
      await this.gms.loading();
      this.requestParams = {
        user: this.user,
        s_ins: this.currentInstallation.s_ins
      };
      try {
        this.codewordsList = await this.protocolService.getInstallationCodewords(this.requestParams);
      } catch (e) {
        const message = JSON.stringify(e);
        await FirebaseCrashlytics.recordException({ message: message });
        this.modalCtrl.dismiss(false, '', 'loadSpinner');
      }
      if (this.codewordsList != null) {
        let codeWord: Codeword = this.codewordsList.find(word => word.tp === type);
        this.modalCtrl.dismiss(false, '', 'loadSpinner');
        if (codeWord !== null) {
          if (codeWord === undefined) {
            let ix: number;
            switch (type) {
              case "CRA":
                ix = 1;
                break;
              case "CLI":
                ix = 2;
                break;
              case "COA":
                ix = 3;
                break;
            }
            codeWord = new Codeword(type, ix);
          };
          // open modal default
          const contentModal = await this.modalCtrl.create({
            component: WordOfDuressComponent,
            id: "wordDuress",
            componentProps: {
              codeWord: codeWord,
              user: this.user,
              s_ins: this.currentInstallation.s_ins,
              codeWordList: this.codewordsList
            },
            cssClass: ['modal-default'],
          });

          contentModal.onDidDismiss().then(res => {
            this.zone.run(async () => {
              if (res.data != null && res.data.result) {
                await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleInfo'), await this.translate.getTranslate('MESSAGES.changeCodeWordOk'),
                  'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
              }
            });
          });
          contentModal.present().then();
          this.isServiceBusy = false;
        } else {
          await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleInfo'), await this.translate.getTranslate('MESSAGES.notFoundCodeWord'),
            'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
        }
      }
    } else {
      await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.noInternetConnection'),
        'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
    }
  }

  async checkExpirationAuth(type: string) {
    const expirationAuth: boolean = await this.gms.checkExpirationAuth();
    if (!expirationAuth) {
      const result = await this.gms.getCheckBiometricAuth((await this.authService.getUserLogin(this.gvs.user)).activeBiometric);
      if (result) {
        await this.authService.setExpirationAuth();
        await this.wordOfDuressModal(type);
      } else {
        return;
      }
    } else {
      await this.wordOfDuressModal(type);
    }
  }
}
